import Image from "next/image";
import Link from "next/link";
import { Typography, Skeleton, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useMemo } from "react";
import { usePathname } from "next/navigation";
import { getPopularsListServices } from "../../redux/slices/common";
import { pathNameServiceTypeMapping } from "../../utils/serviceTypes";

const linkMap = {
    activities:
        "/activities/activities?cityName=All&name=&destinationName=All&productId=",
    holidays:
        "/holidays/holidays?country=&cityName=All&name=&adult=1&child=0&rooms=1&productId=",
    staycation:
        "/staycation/staycations?cityName=All&name=&checkIn=&checkOut=&productId=",
    bus: "/busBooking/busRentals?cityName=All&name=All&pickupDateTime=2025-04-04&pickupDateTimecheckOutDate=2025-04-05&pickupTimeValue=&productId=&type=All",
};

const Trending = ({ router, pageName, title = "Trending" }) => {
    const dispatch = useDispatch();
    const pathname = usePathname();
    const [services, setServices] = useState([]);
    const { popularList } = useSelector((state) => state.common);
    const [isPopularDisabled, setIsPopularDisabled] = useState(false);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        const isFlightOrHotels = pageName === "flights" || pageName === "hotels";
        const serviceType = pathNameServiceTypeMapping[pageName];

        if (!isFlightOrHotels) {
            setLoader(true);
            setServices([]);
            dispatch(getPopularsListServices(serviceType));
        }

        setIsPopularDisabled(isFlightOrHotels);
    }, [router.asPath]);

    useEffect(() => {
        if (popularList && popularList?.responseData?.length > 0) {
            setTimeout(() => {
                setLoader(false);
                setServices(popularList.responseData);
            }, 200);
        }
    }, [popularList]);


    // console.log("loader", loader);


    const typeKey = useMemo(() => {
        if (typeof pathname !== "string") return null;
        if (pathname.includes("/activities")) return "activities";
        if (pathname.includes("/holidays")) return "holidays";
        if (pathname.includes("/staycation")) return "staycation";
        if (pathname.includes("/bus")) return "bus";
        return null;
    }, [pathname]);

    const dynamicHref = typeKey ? linkMap[typeKey] : "#";

    if (isPopularDisabled) {
        return null;
    }

    const typePaths = {
        4: "/staycation/staycation-details",
        6: "/activities/activity-details",
        7: "/busrental/bus-details",
        8: "/holidaypackage/holiday-details",
        9: "/carrentalnew/car-details",
    };
    const getTypePath = (type) => typePaths[type] || "";

    return (
        <div className="trending-static-container mt-2 mt-md-5 mb-0">

            <Image
                src="/img/header/cloud12.svg"
                alt="Photo stack"
                className="decor decor-left"
                width={50}
                height={50}
            />

            <Image
                src="/img/header/camera.svg"
                alt="Camera"
                className="decor decor-top-right"
                width={50}
                height={50}
            />


            <div className="trending-grid-layout">
                {/* Cards 1–4 as usual */}
                {services?.slice(0, 4)?.map((item, index) => (
                    <Link
                        key={index}
                        href={`${getTypePath(item.type)}?_id=${item?._id}`}
                        className={`trending-card-layout ${index === 0 ? "card-11" : `card-${index + 1}`}`}
                    >
                        <Image
                            width={600}
                            height={400}
                            alt={item.name}
                            src={`${process.env.IMAGE_BASE_URL}/${item?.image}`}
                            className="trending-img-layout"
                            onError={(e) => (e.currentTarget.src = "/fallback-image.jpg")}
                        />
                        <div className="trending-overlay-layout">
                            <h3 className="trending-title-layout">{item.name}</h3>
                        </div>
                    </Link>
                ))}

                {/* ✅ Nested bottom row grid for cards 5–7 */}
                <div className="bottom-row">
                    {services?.slice(4, 7)?.map((item, index) => (
                        <Link
                            key={index}
                            href={`${getTypePath(item.type)}?_id=${item?._id}`}
                            className={`trending-card-layout card-${index + 5}`}
                        >
                            <Image
                                width={600}
                                height={400}
                                alt={item.name}
                                src={`${process.env.IMAGE_BASE_URL}/${item?.image}`}
                                className="trending-img-layout"
                                onError={(e) => (e.currentTarget.src = "/fallback-image.jpg")}
                            />
                            <div className="trending-overlay-layout">
                                <h3 className="trending-title-layout">{item.name}</h3>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Trending;
